import { render, staticRenderFns } from "./EvaluacionOdontologica.vue?vue&type=template&id=a281706c"
import script from "./EvaluacionOdontologica.vue?vue&type=script&lang=js"
export * from "./EvaluacionOdontologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports